import styled from "styled-components";
import { AppTheme } from "../../theme";

declare module "styled-components" {
  export interface DefaultTheme extends AppTheme {}
}
interface MSWindowBottomBarContainerProps {
  showBottomBar: boolean;
}

export const MSWindowContainer = styled.div<{ $maximized?: boolean }>`
  // width: 100%;
  // max-width: 700px;
  height: fit-content;
  flex-shrink: 0;
  background: ${(props) => props.theme.MSBackground};
  box-shadow: ${(props) => props.theme.standardBoxShadow};
  padding: 4px;
  display: flex;
  flex-direction: column;
  resize: both;
  ${(props) => props.$maximized && "width: 100%; height: 100%;"}

  @media (min-width: 768px) {
    // width: 700px;
  }
`;

export const MSWindowBarsContainer = styled.div`
  flex-shrink: 0;
`;

export const MSWindowTopBarContainer = styled.div<{ $active?: boolean }>`
  width: 100%;
  min-height: 18px;
  background: ${(props) =>
    props.$active
      ? props.theme.barGradient
      : "linear-gradient(270deg, #b5b5b5 0%, #808080 100%)"};
  transition: background 0.2s;
  cursor: grab;
  user-select: none;
  &:active {
    cursor: grabbing;
  }
  color: ${(props) => props.theme.white};
  padding: 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${(props) => props.theme.fontNormal}px;
  // font-weight: bold;
`;

export const MSWindowTopBarImage = styled.img`
  height: 18px;
`;
export const MSWindowTopBarButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1px;
`;

export const MSWindowTopBarButton = styled.button`
  background: ${(props) => props.theme.MSBackground};
  box-shadow: ${(props) => props.theme.standardBoxShadow};
  width: 16px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  border: none;
  &:active {
    box-shadow: ${(props) => props.theme.invertedStandardBoxShadow};
  }
`;

export const MSWindowTopBarButtonMinimiseBar = styled.div`
  position: absolute;
  width: 6px;
  height: 2px;
  background: ${(props) => props.theme.black};
  bottom: 3px;
`;

export const MSWindowBottomBarContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "showBottomBar",
})<MSWindowBottomBarContainerProps>`
  width: 100%;
  min-height: 20px;
  font-size: ${(props) => props.theme.fontNormal}px;
  word-spacing: 10px;
  padding: 2px 0;
  cursor: pointer;
  display: ${(props) => (props.showBottomBar ? "" : "none")};
`;

export const MSWindowContent = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isWebsite",
})<{
  isWebsite: boolean;
  $maximized?: boolean;
}>`
  width: 100%;
  height: 100%;
  flex-grow: 1;
  ${(props) =>
    props.$maximized &&
    `
    min-height: 0;
    overflow: auto;
    /* stretch whatever is inside (browser iframe, explorer, etc) to fill */
    & > * {
      width: 100% !important;
      height: 100% !important;
      max-width: none !important;
    }
  `}
  background: ${(props) =>
    props.isWebsite ? props.theme.white : props.theme.MSBackground};
`;

export const UnderLineSpan = styled.span`
  text-decoration: underline;
`;

export const MSAddressBarContainer = styled.div`
  width: 100%;
  min-height: 20px;
  font-size: ${(props) => props.theme.fontNormal}px;
  padding: 2px 0;
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const MSAddressBar = styled.div`
  background: ${(props) => props.theme.white};
  box-shadow: ${(props) => props.theme.invertedStandardBoxShadow};
  width: 100%;
  padding: 4px;
  display: flex;
  min-height: 20px;
  align-items: center;
`;
